import routerOptions0 from "/Users/yuto.yasuoka/Project/chirashi-viewer/app/router.options.ts";
import routerOptions1 from "/Users/yuto.yasuoka/Project/chirashi-viewer/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions1,
...routerOptions0,
}